import { NgModule } from "@angular/core";
import { UUIDValidator } from "./uuid/directive";
import { Base64Validator } from "./base64/directive";
import { CreditCardValidator } from "./credit-card/directive";
import { DateValidator } from "./date/directive";
import { DateISOValidator } from "./date-iso/directive";
import { DigitsValidator } from "./digits/directive";
import { EqualValidator } from "./equal/directive";
import { UrlValidator } from "./url/directive";
import { RangeLengthValidator } from "./range-length/directive";
import { PhoneValidator } from "./phone/directive";
import { NotEqualValidator } from "./not-equal/directive";
import { MinDateValidator } from "./min-date/directive";
import { MaxValidator } from "./max/directive";
import { RangeValidator } from "./range/directive";
import { NotEqualToValidator } from "./not-equal-to/directive";
import { EqualToValidator } from "./equal-to/directive";
import { GreaterThanValidator } from "./greater-than/directive";
import { GreaterThanEqualValidator } from "./greater-than-equal/directive";
import { JSONValidator } from "./json/directive";
import { LessThanValidator } from "./less-than/directive";
import { LessThanEqualValidator } from "./less-than-equal/directive";
import { MaxDateValidator } from "./max-date/directive";
import { MinValidator } from "./min/directive";
import { EmailValidator } from "./email/directive";
import { NumberValidator } from "./number/directive";

@NgModule({
  declarations: [
    Base64Validator,
    CreditCardValidator,
    DateValidator,
    DateISOValidator,
    DigitsValidator,
    EmailValidator,
    EqualValidator,
    EqualToValidator,
    GreaterThanValidator,
    GreaterThanEqualValidator,
    JSONValidator,
    LessThanValidator,
    LessThanEqualValidator,
    MaxValidator,
    MaxDateValidator,
    MinValidator,
    MinDateValidator,
    NotEqualValidator,
    NotEqualToValidator,
    NumberValidator,
    PhoneValidator,
    RangeValidator,
    RangeLengthValidator,
    UrlValidator,
    UUIDValidator
  ],
  exports: [
    Base64Validator,
    CreditCardValidator,
    DateValidator,
    DateISOValidator,
    DigitsValidator,
    EmailValidator,
    EqualValidator,
    EqualToValidator,
    GreaterThanValidator,
    GreaterThanEqualValidator,
    JSONValidator,
    LessThanValidator,
    LessThanEqualValidator,
    MaxValidator,
    MaxDateValidator,
    MinValidator,
    MinDateValidator,
    NotEqualValidator,
    NotEqualToValidator,
    NumberValidator,
    PhoneValidator,
    RangeValidator,
    RangeLengthValidator,
    UrlValidator,
    UUIDValidator
  ]
})
export class ValidatorModule {}
